<template>
    <main class="app-main">
        <section class="contact">
            <h1 class="allproducts__title">Контакти</h1>
            <div class="contact__map">
                <GMap></GMap>
            </div>
            <div class="contact__form">
                <div class="contact__form-header">
                    <div class="row" v-if="settings">
                        <div class="contact__s-column contact__form-header--text">
                            <img src="/static/images/home.png" />
                            {{ settings.address }}
                        </div>
                        <div class="contact__s-column contact__form-header--text">
                            <img src="/static/images/phone.png" />
                            <a :href="'tel:+'+settings.phone">{{ settings.phone }}</a>
                        </div>
                        <div class="contact__s-column contact__form-header--text">
                            <img src="/static/images/envelope.png" />
                            <a :href="'mailto:'+settings.email">{{ settings.email }}</a>
                        </div>
                    </div>
                </div>
                <div class="contact__form-main">
                    <form method="POST" id="contact" @submit.prevent="onSubmit">
                        <div class="row">
                            <div class="contact__m-column">
                                <div class="contact__form-group contact__form-group--first">
                                    <label for="name">Вашите имена</label>
                                    <input v-model="form.name" type="text" id="name" class="contact__input" name="name" />
                                    <span class="contact__form-group--error" v-if="errors.name" v-text="errors.name"></span>
                                </div>
                            </div>
                            <div class="contact__m-column">
                                <div class="contact__form-group">
                                    <label for="email">Вашия email</label>
                                    <input v-model="form.email" type="email" id="email" class="contact__input" name="email" />
                                    <span class="contact__form-group--error" v-if="errors.email" v-text="errors.email"></span>
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="contact__l-column">
                                <div class="contact__form-group">
                                    <label for="message">Вашето съобщение</label>
                                    <textarea v-model="form.message" name="message" id="message" class="contact__input contact__input--textarea"></textarea>
                                    <span class="contact__form-group--error" v-if="errors.message" v-text="errors.message"></span>
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="contact__l-column contact__btn">
                                <button class="btn btn--success">Изпрати</button>
                            </div>
                        </div>
                    </form>
                    <br />
                    <div v-if="formData && formData.success" v-text="formData.message" class="alert alert__success"></div>
                </div>
            </div>
        </section>
    </main>
</template>

<script>
import GMap from './Map'
import Form from '@/services/form'

export default {
    name: 'Contacts',
    components: { GMap },
    data () {
        return {
            baseUrl: this.$root.$data.baseUrl,
            form: {
                name: '',
                email: '',
                message: ''
            },
            errors: {
                name: null,
                email: null,
                message: null
            },
            formData: null,
            settings: this.$root.$data.settings
        }
    },
    head: {
        title: {
            inner: 'Bimbi',
            complement: 'Контакти'
        },
        script: [
            { type: 'text/javascript', src: 'https://www.googletagmanager.com/gtag/js?id=UA-107886446-1', async: true }
        ]
    },
    methods: {
        onSubmit: function (e) {
            e.preventDefault()

            this.errors = {
                name: null,
                email: null,
                message: null
            }

            const contactForm = new Form({ name: this.form.name, email: this.form.email, message: this.form.message })

            contactForm.validationRules({
                name: 'required',
                email: 'required',
                message: 'required'
            })

            let errors = contactForm.errors
            if (errors && errors.length) {
                for (let error of errors) {
                    this.errors[error.key] = error.message
                }
            } else {
                contactForm.send(`${this.baseUrl}/contacts`, document.getElementById('contact'))
                    .then(({data}) => {
                        if (data && data.success) {
                            this.formData = data
                            if (this.formData && this.formData.errors.length) {
                                let keys = Object.keys(this.formData.errors)
                                for (let key of keys) {
                                    this.errors[key] = this.formData.errors[key]
                                }
                            }

                            return
                        }

                        return new Error(`Error`)
                    })
                    .catch((res) => {
                        console.log(res)
                        let data = res.response.data
                        if (data && data.errors) {
                            let keys = Object.keys(data.errors)
                            for (let key of keys) {
                                this.errors[key] = data.errors[key][0]
                            }
                        }
                    })
            }
        }
    }
}
</script> 




// WEBPACK FOOTER //
// src/components/Contacts.vue?b795f79a